import { inject, Injectable } from '@angular/core';
import { FUSE_CONFIG } from '@fuse/services/config/config.constants';
import { merge } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';
import { darkTheme, lightTheme } from 'app/layout/common/themeswitch/theme.config';

@Injectable({ providedIn: 'root' })
export class FuseConfigService {
    private _config = new BehaviorSubject(inject(FUSE_CONFIG));

    constructor() {
        const initialScheme = this._config.getValue().scheme || 'light';
        this.applyTheme(initialScheme === 'dark' ? darkTheme : lightTheme);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for config
     */
    set config(value: any) {
        // Merge the new config over to the current config
        const config = merge({}, this._config.getValue(), value);

        // Execute the observable
        this._config.next(config);

        // Apply chosen theme
        if (value.scheme) {
            this.applyTheme(value.scheme === 'dark' ? darkTheme : lightTheme);
        }
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    get config$(): Observable<any> {
        return this._config.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resets the config to the default
     */
    reset(): void {
        // Set the config
        this._config.next(this.config);
    }

    private applyTheme(theme: any): void {
        for (const [property, value] of Object.entries(theme.properties)) {
            document.documentElement.style.setProperty(property, value as string);
        }
    }
}
